// import logo from './logo.svg';
import './App.css';
import Drawing from './component/Drawing.tsx';
import image1 from './download.png';
import Navigation from "./component/Navigation.jsx";


function App() {
  return (
    <div className="App">
        <header className="App-header">
            <Navigation />
        </header>
        <div className="Drawing-Name">
            <Drawing />
        </div>
        <div className="Subheading-Name">
            <h2>Computer Science undergraduate student at MSOE</h2>
            <h2>Something else will go here</h2>
        </div>
        <div>
            This will change
            {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
            <img src={image1} alt={"Image of Neural Network"} width={"50%"}/>
        </div>
        <div className="TimeLine">
            <h2>Time Line / Projects</h2>
        </div>
    </div>
  );
}

export default App;
